import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import questionAnswers from "./questionSet";
import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";
import QuestionScreen from "../../components/QuestionScreen";
import WrongMoveModal from "../../components/WrongMoveModal";
import EvaluatorModal from "../../components/EvaluatorModal";
import InfoModal from "../../components/InfoModal";

const QuizScreen = (props) => {
  const { classes, setCurrentScreen, setAnswers, answers, ...others } = props;

  const [questionIndex, setQuestionIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [resetGraph, setResetGraph] = useState(false);
  const [answeredCorrectly, setAnsweredCorrectly] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);

  const modalOpen = () => setOpen(true);

  const closeModal = () => {
    setInfoModalOpen(false);
  };

  useEffect(() => {
    if (questionIndex === 0 || questionIndex === 4) {
      setInfoModalOpen(true);
    }
  }, [questionIndex]);

  const nextQuestion = () => {
    setOpen(false);
    setAnswers([...answers, answeredCorrectly]);
    if (questionIndex >= questionAnswers.length - 1) setCurrentScreen("Result");
    else {
      setQuestionIndex(questionIndex + 1);
    }
  };

  console.log("questionIndex: ", questionIndex);

  return (
    <div className={classes.quizScreenContainer}>
      <QuestionScreen
        {...others}
        questionAnswer={questionAnswers[questionIndex]}
        modalOpen={modalOpen}
        nextQuestion={nextQuestion}
        key={questionIndex}
        questionIndex={questionIndex}
        setAnsweredCorrectly={setAnsweredCorrectly}
      />
      {(questionIndex === 0 || questionIndex === 5) && (
        <InfoModal
          infoText={questionIndex === 0 ? `When demand is MORE ELASTIC (or "less inelastic"), consumers are VERY responsive to price. A small price increase will result in a large reduction in quantity demanded. Conversely, a small decrease in price will result in a large increase in quantity demanded.` : "When demand is MORE INELASTIC (or “less elastic”), consumers are NOT VERY responsive to price changes. A large increase in price leads to only a small decrease in quantity demanded, and a large decrease in price leads to only a small increase in quantity demanded." }
          closeModal={closeModal}
          open={infoModalOpen}
        />
      )}
      {open && (
        <EvaluatorModal
          answeredCorrectly={answeredCorrectly}
          nextQuestion={nextQuestion}
          question={questionAnswers[questionIndex]}
        />
      )}
    </div>
  );
};

export default withStyles(styles)(QuizScreen);
